var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiuxDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.995 19.995H0V0H19.995V19.995ZM3.99125 16.0037H16.0037V3.99125H3.99125V16.0037Z",
    fill: "#FD5956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124 19.995H104.005V0H124V19.995ZM107.996 16.0037H119.989V3.99125H107.996V16.0037Z",
    fill: "#FD5956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9975 19.995H52.0025V0H71.9975V19.995ZM55.9937 16.0037H68.0062V3.99125H55.9937V16.0037Z",
    fill: "#FD5956"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.995 124H0V104.005H19.995V124ZM3.99125 120.009H16.0037V107.996H3.99125V120.009Z",
    fill: "#FD5956"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.995 71.9975H0V52.0025H19.995V71.9975ZM3.99125 68.0062H16.0037V55.9937H3.99125V68.0062Z",
    fill: "#FD5956"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124 71.9975H104.005V52.0025H124V71.9975ZM107.996 68.0062H119.989V55.9937H107.996V68.0062Z",
    fill: "#FD5956"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124 124H104.005V104.005H124V124ZM107.996 120.009H119.989V107.996H107.996V120.009Z",
    fill: "#FD5956"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9975 124H52.0025V104.005H71.9975V124ZM55.9937 120.009H68.0062V107.996H55.9937V120.009Z",
    fill: "#FD5956"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9981 8.00187H17.9994V11.9931H53.9981V8.00187Z",
    fill: "#FD5956"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 8.00187H70.0019V11.9931H106.001V8.00187Z",
    fill: "#FD5956"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9981 112.007H17.9994V115.998H53.9981V112.007Z",
    fill: "#FD5956"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 112.007H70.0019V115.998H106.001V112.007Z",
    fill: "#FD5956"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 17.9994H112.007V53.9981H115.998V17.9994Z",
    fill: "#FD5956"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 70.0019H112.007V106.001H115.998V70.0019Z",
    fill: "#FD5956"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9931 17.9994H8.00187V53.9981H11.9931V17.9994Z",
    fill: "#FD5956"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9931 70.0019H8.00187V106.001H11.9931V70.0019Z",
    fill: "#FD5956"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103.753L38.75 38.75L103.753 62L73.625 73.625L62 103.753ZM45.2987 45.2987L62 92.2444L70.3894 70.4475L92.2444 62L45.2987 45.2987Z",
    fill: "#FD5956"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9963 24.0056H42.005V32.0075H45.9963V24.0056Z",
    fill: "#FD5956"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2702 28.4523L28.448 31.2745L34.1062 36.9327L36.9284 34.1104L31.2702 28.4523Z",
    fill: "#FD5956"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0075 42.005H24.0056V45.9963H32.0075V42.005Z",
    fill: "#FD5956"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1042 51.0666L28.446 56.7248L31.2683 59.5471L36.9265 53.8889L34.1042 51.0666Z",
    fill: "#FD5956"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9963 55.9937H42.005V63.9956H45.9963V55.9937Z",
    fill: "#FD5956"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9956 42.005H55.9937V45.9963H63.9956V42.005Z",
    fill: "#FD5956"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7205 28.4542L51.0623 34.1124L53.8846 36.9346L59.5428 31.2764L56.7205 28.4542Z",
    fill: "#FD5956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxDesign);
export default __webpack_public_path__ + "static/media/uiux_design.e11bba28c22c9c9418928267ea9ba8b6.svg";
export { ForwardRef as ReactComponent };